import {dateFormat, numberFormat} from "./Utils.js";

export default class Renders
{
    transaction(transaction, template, addCreatedBy, approvedAsText, modalSize) {
        template.dataset.id = transaction.transaction_id;

        if (transaction.status === 'approved') {
            template.classList.remove('inactive-element');
        } else {
            template.classList.add('inactive-element');
        }

        const fieldCategory = template.querySelector('.grid__row .grid__cell--category span');
        const categoryValue = Object.values(transaction.categories).reverse().map(cat => Object.values(cat)[0]).join(JOINING_SYMBOL);
        fieldCategory.dataset.tooltip = categoryValue;
        fieldCategory.textContent = categoryValue;

        const amount = template.querySelector('.grid__row .grid__cell--amount span');
        amount.innerHTML = (transaction.type === 'expense' ? '<span class="minus">-</span>' : '') + numberFormat(transaction.amount);
        amount.classList.add((transaction.type === 'expense' ? 'negative' : 'positive'));

        const fieldComment = template.querySelector('.grid__row .grid__cell--comment span');

        if (transaction.comment) {
            fieldComment.dataset.tooltip = transaction.comment;
            fieldComment.textContent = transaction.comment;
            fieldComment.classList.remove('grid__cell--empty');
        } else {
            fieldComment.classList.add('grid__cell--empty');
            fieldComment.textContent = '-';
        }

        const spacesField = template.querySelector('.grid__row .grid__cell--spaces');

        let spaces = Object.values(transaction.spaces || {}).map(space => space.name);
        const howManySpaces = Object.keys(spaces).length;

        if (howManySpaces) {
            const allSpaces = spaces.join(', ');
            spacesField.innerHTML = '<span class="text" data-tooltip="' + allSpaces + '">' + allSpaces + '</span>';
        } else {
            spacesField.innerHTML = '<span class="grid__cell--empty">-</span>';
        }

        if (addCreatedBy) {
            const spacesCell = template.querySelector('.grid__row .grid__cell--spaces');

            if (spacesCell) {
                const cell = document.createElement('div');
                cell.className = 'grid__cell grid__cell--created-by' + (modalSize === 'big' ? ' grid__cell--center' : '');
                cell.setAttribute('data-label', 'Created by');
                cell.dataset.i18n = 'label_created_by';

                const span = document.createElement('span');
                span.className = 'text';

                let ownerName = transaction.owner_display_name;

                if (USER.id === transaction.transaction_user_id) {
                    ownerName = __('transactions.label_you');
                } else {
                    cell.classList.add('available');
                }

                span.textContent = ownerName;
                span.setAttribute('data-tooltip', ownerName);

                cell.appendChild(span);
                spacesCell.insertAdjacentElement('afterend', cell);
            }
        }

        template.querySelector('.grid__row .grid__cell--date').innerHTML = '<span class="text" data-tooltip="' + dateFormat(transaction.created_at) + '">' + dateFormat(transaction.created_at) + '</span>';
        template.querySelector('button:last-child').dataset.href = '/' + SYSTEM_LANGUAGE + '/transactions/' + transaction.transaction_id + '/edit';

        if (approvedAsText) {
            let span = document.createElement('span');
            span.classList.add((transaction.status === 'approved' ? 'positive' : 'warning'));
            span.textContent = (transaction.status === 'approved' ? __('label_yes') : __('label_no'));

            template.querySelector('#transaction-toggle-approved').parentNode.replaceWith(span);
        } else {
            if (transaction.status === 'approved') {
                template.querySelector('#transaction-toggle-approved').checked = true;
            }
        }

        if (transaction.transaction_user_id !== window.USER.id) {
            template.querySelector('.button:last-child').remove();
        }

        __All(template);

        return template;
    }

    scheduledTransaction(transaction, template) {
        template.dataset.id = transaction.transaction_id;

        if (transaction.is_active) {
            template.classList.remove('inactive-element');
        } else {
            template.classList.add('inactive-element');
        }

        const fieldCategory = template.querySelector('.grid__row .grid__cell--category span');
        const categoryValue = Object.values(transaction.categories).reverse().map(cat => Object.values(cat)[0]).join(JOINING_SYMBOL);
        fieldCategory.dataset.tooltip = categoryValue;
        fieldCategory.textContent = categoryValue;

        const amount = template.querySelector('.grid__row .grid__cell--amount span');
        amount.innerHTML = (transaction.type === 'expense' ? '<span class="minus">-</span>' : '') + numberFormat(transaction.amount);
        amount.classList.add((transaction.type === 'expense' ? 'negative' : 'positive'));

        // const fieldComment = template.querySelector('.grid__row .grid__cell--comment span');
        //
        // if (transaction.comment) {
        //     fieldComment.dataset.tooltip = transaction.comment;
        //     fieldComment.classList.remove('grid__cell--empty');
        //     fieldComment.textContent = transaction.comment;
        // }

        const scheduledRuleParams = { ...transaction.scheduled_rule.params };

        if ('month' in scheduledRuleParams) {
            scheduledRuleParams.month = __(scheduledRuleParams.month);
        }

        if ('day' in scheduledRuleParams && isNaN(scheduledRuleParams.day)) {
            scheduledRuleParams.day = __(scheduledRuleParams.day);
        }

        const rule = __(transaction.scheduled_rule.key, scheduledRuleParams);

        template.querySelector('.grid__row .grid__cell--rule span').dataset.tooltip = rule;
        template.querySelector('.grid__row .grid__cell--rule span').textContent = rule;

        if (transaction.next_run_at) {
            template.querySelector('.grid__row .grid__cell--next-run-at').textContent = dateFormat(transaction.next_run_at);
        }

        if (transaction.last_run_at) {
            template.querySelector('.grid__row .grid__cell--last-run-at').textContent = dateFormat(transaction.last_run_at);
        }

        if (transaction.manual_runs) {
            template.querySelector('.grid__row .grid__cell--manual-runs').textContent = transaction.manual_runs;
        }

        if (transaction.auto_runs) {
            template.querySelector('.grid__row .grid__cell--auto-runs').textContent = transaction.auto_runs;
        }

        if (transaction.max_runs) {
            template.querySelector('.grid__row .grid__cell--max-runs').textContent = transaction.max_runs;
        }

        if (transaction.start_after) {
            template.querySelector('.grid__row .grid__cell--start-after').textContent = dateFormat(transaction.start_after);
        }

        template.querySelector('.grid__row .grid__cell--frequency-type').textContent = __('freq_' + transaction.frequency_type.toLowerCase());
        
        const status = template.querySelector('.grid__row .grid__cell--status');
        status.classList.replace('status-', 'status-' + transaction.status);
        template.querySelector('.grid__row .grid__cell--status span').textContent = __('label_' + transaction.status.toLowerCase());

        const spacesField = template.querySelector('.grid__row .grid__cell--spaces');

        let spaces = Object.values(transaction.spaces || {}).map(space => space.name);
        const howManySpaces = Object.keys(spaces).length;

        if (howManySpaces) {
            const allSpaces = spaces.join(', ');
            spacesField.innerHTML = '<span class="text" data-tooltip="' + allSpaces + '">' + allSpaces + '</span>';
        } else {
            spacesField.innerHTML = '<span class="grid__cell--empty">-</span>';
        }

        template.querySelector('.grid__row .grid__cell--active').remove();

        if (transaction.transaction_user_id !== window.USER.id) {
            template.querySelector('.grid__row .grid__cell--options').remove();
        } else {
            template.querySelector('button:first-child').remove();
            template.querySelector('button:last-child').dataset.href = '/' + SYSTEM_LANGUAGE + '/scheduled-transactions/' + transaction.transaction_id + '/edit';
        }

        __All(template);

        return template;
    }

    transactionTemplate(tmp, template) {
        template.dataset.id = tmp.template_id;
        template.dataset.position = tmp.position;

        template.querySelector('.grid__row .grid__cell--name span').textContent = tmp.name;
        template.querySelector('.grid__row .grid__cell--position span').textContent = tmp.position;

        const fieldCategory = template.querySelector('.grid__row .grid__cell--category span');
        const categoryValue = Object.values(tmp.categories).reverse().map(cat => Object.values(cat)[0]).join(JOINING_SYMBOL);
        fieldCategory.dataset.tooltip = categoryValue;
        fieldCategory.textContent = categoryValue;

        const amount = template.querySelector('.grid__row .grid__cell--amount span');
        amount.innerHTML = (tmp.type === 'expense' ? '<span class="minus">-</span>' : '') + numberFormat(tmp.amount);
        amount.classList.add((tmp.type === 'expense' ? 'negative' : 'positive'));

        const fieldComment = template.querySelector('.grid__row .grid__cell--comment span');

        if (tmp.comment) {
            fieldComment.dataset.tooltip = tmp.comment;
            fieldComment.textContent = tmp.comment;
        } else {
            fieldComment.innerHTML = '<span class="grid__cell--empty">-</span>';
        }

        const spacesField = template.querySelector('.grid__row .grid__cell--spaces');
        let spaces = Object.values(tmp.spaces || {}).map(space => space.name);
        const howManySpaces = Object.keys(spaces).length;

        if (howManySpaces) {
            const allSpaces = spaces.join(', ');
            spacesField.innerHTML = '<span class="text" data-tooltip="' + allSpaces + '">' + allSpaces + '</span>';
        } else {
            spacesField.innerHTML = '<span class="grid__cell--empty">-</span>';
        }

        template.querySelector('.grid__row .grid__cell--date').textContent = dateFormat(tmp.created_at);
        template.querySelector('button:last-child').dataset.href = '/' + SYSTEM_LANGUAGE + '/transaction-templates/' + tmp.template_id + '/edit';

        __All(template);

        return template;
    }

    note(note, template) {
        template.dataset.note_id = note.id;
        template.querySelector('.placeholder__content').textContent = note.text;
        template.querySelector('.placeholder__footer span:first-child').textContent = dateFormat(note.created_at);
        template.closest('.placeholder').querySelector('.placeholder__header .text').dataset.tooltip = note.name;
        template.closest('.placeholder').querySelector('.placeholder__header .text').textContent = note.name;

        return template
    }
}